import { render } from "./AccountsContext.vue?vue&type=template&id=265db3d4"
import script from "./AccountsContext.vue?vue&type=script&lang=js"
export * from "./AccountsContext.vue?vue&type=script&lang=js"

import "./AccountsContext.vue?vue&type=style&index=0&id=265db3d4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__